/**
 * DO NOT MANUALLY EDIT THIS FILE
 * This file is generated automatically by the build script on prebuild step.
 * Please refer to documentation for more information
 */

export default function MetaCategories({ children }) {
  return children({
    art: [
      'dessins',
      'peintures',
      'pop-art',
      'photographie',
      'collage',
      'collage/photo',
      'abstrait',
      'edition',
      'dessins/botanique/fleur',
      'sculpture',
      'photographie/portrait',
      'peintures/huile',
      'photographie/nu',
      'dessins/dessin-anime',
      'edition/lino',
      'dessins/animaux',
      'conceptuel',
      'nu',
      'street-art',
      'digital',
      'photographie/nature-morte',
      'peintures/abstrait',
      'peintures/paysage',
      'peintures/botanique/fleur',
      'paysage',
      'photographie/faune',
      'photographie/nature',
      'edition/botanique',
      'photographie/documentaire',
      'photographie/architecture',
      'dessins/crayon',
      'impressionniste',
      'photographie/abstrait',
      'nature-morte',
      'installation',
      'peintures/acrylique',
      'nature',
      'graphique',
      'fantastique',
      'photographie/surrealiste',
      'edition/animaux',
      'geometrique',
      'minimaliste',
      'sport/football',
      'photographie/urbain',
      'photographie/botanique/fleur',
      'photographie/sport',
      'peintures/nu',
      'dessins/fusain',
      'typographie',
      'digital/vectoriel',
      'sculpture/ceramique',
      'art-deco',
      'peintures/nature-morte',
      'dessins/encre',
      'dessins/animaux/cheval',
      'dessin-anime',
      'figuratif',
      'animaux',
      'botanique/fleur',
      'urbain',
      'faune',
      'sculpture/bois',
      'sculpture/metal',
      'photographie/animaux',
      'peintures/animaux',
      'dessins/nature-morte',
      'dessins/animaux/chat',
      'sculpture/bronze',
      'animaux/cheval',
      'nourriture',
      'edition/botanique/fleur',
      'peintures/paysage-marin',
      'dessins/animaux/chien',
      'surrealiste',
      'peintures/nature',
      'musique',
      'sculpture/papier',
      'sculpture/verre',
      'peintures/paysage/plage',
      'photographie/animaux/cheval',
      'peintures/animaux/chat',
      'peintures/animaux/chien',
      'dessins/pastel',
      'dessins/botanique',
      'animaux/chat',
      'mode',
      'cartes',
      'sport/cyclisme',
      'peintures/animaux/cheval',
      'dessins/paysage',
      'photographie/technique-mixte',
      'edition/abstrait',
      'edition/urbain',
      'edition/paysage',
      'dessins/geometrique',
      'dessins/nu',
      'sculpture/animaux',
      'expressionniste',
      'animaux/chien',
      'sculpture/resine',
      'peintures/portrait',
      'edition/fantastique',
      'peintures/art-deco',
      'dessins/craie',
      'sculpture/pierre',
      'sculpture/abstrait',
      'cubisme',
      'photographie/paysage/plage',
      'edition/pop-art',
      'edition/paysage-urbain/paris',
      'peintures/spiritualite/religion',
      'dessins/abstrait',
      'paysage-urbain/new-york',
      'dessins/architecture',
      'peintures/figuratif',
      'peintures/paysage-urbain/paris',
      'paysage-urbain/paris',
      'sport',
      'edition/serigraphie',
      'dessins/portrait',
      'photographie/fantastique',
      'photographie/paysage-urbain',
      'photographie/celebrites',
      'collage/technique-mixte',
      'collage/papier',
      'edition/gravure',
      'peintures/pop-art',
      'peintures/geometrique',
      'dessins/pop-art',
      'architecture',
      'photographie/paysage-marin',
      'photographie/pop-art',
      'photographie/street-art',
      'collage/paysage',
      'peintures/technique-mixte',
      'paysage-urbain',
      'paysage-marin',
      'collage/pop-art',
      'peintures/architecture',
      'paysage-urbain/londres',
      'peintures/paysage-urbain',
      'peintures/encre',
      'celebrites',
      'peintures/botanique',
      'illustration',
      'peintures/portrait/femme',
      'edition/expressionnisme-abstrait',
      'peintures/fantastique',
      'photographie/paysage',
      'edition/dessin-anime',
      'collage/figuratif',
      'dessins/figuratif',
      'sculpture/figuratif',
      'dessins/cubisme',
      'peintures/cubisme',
      'sculpture/cubisme',
      'collage/expressionniste',
      'dessins/expressionniste',
      'peintures/expressionniste',
      'photographie/expressionniste',
      'collage/geometrique',
      'sculpture/geometrique',
      'collage/illustration',
      'peintures/illustration',
      'dessins/impressionniste',
      'peintures/impressionniste',
      'photographie/impressionniste',
      'peintures/minimaliste',
      'photographie/realisme',
      'collage/street-art',
      'dessins/street-art',
      'installation/street-art',
      'peintures/street-art',
      'edition/street-art',
      'collage/surrealiste',
      'dessins/surrealiste',
      'peintures/surrealiste',
      'peintures/aerographe',
      'peintures/aquarelle',
      'photographie/numerique',
      'edition/lithographie',
      'edition/technique-mixte',
      'photographie/colore',
      'photographie/noir-et-blanc',
      'abstrait/portrait',
      'photographie/paysage/ciel',
      'photographie/noir-et-blanc/portrait',
      'cubisme/portrait',
      'abstrait/paysage',
      'sculpture/nu',
      'abstrait/nu',
      'peintures/acrylique/abstrait',
      'sculpture/pop-art',
      '',
    ],
    artist: [
      'autrichienne',
      'australienne',
      'belge',
      'bresilienne',
      'canadienne',
      'allemande',
      'espagnole',
      'francaise',
      'britannique',
      'italienne',
      'japonaise',
      'neerlandaise',
      'norvegienne',
      'russe',
      'americaine',
      'collagistes',
      'artistes-digital',
      'dessinateurs',
      'artistes-installation',
      'peintres',
      'peintres/impressionnisme',
      'photographes',
      'photographes/femme',
      'photographes/abstrait',
      'photographes/surrealiste',
      'graveurs',
      'sculpteurs',
      'sculpteurs/femme',
      '',
      'africain',
      'asiatique',
      'caribeen',
      'europeen',
      'latino-americain',
      'scandinave',
      'abstrait',
      'abstrait/femme',
      'art-deco',
      'conceptuel',
      'cubisme',
      'dada',
      'expressionnisme',
      'figuratif',
      'geometrique',
      'graphique',
      'illustration',
      'impressionnisme',
      'impressionnisme/femme',
      'minimaliste',
      'realisme-photographique',
      'pop-art',
      'pop-art/femme',
      'street-art',
      'surrealiste',
    ],
  });
}
